import type { StoreRegion } from "@medusajs/types";
import { createFileRoute } from "@tanstack/react-router";
import { FEATURED_BOOK_HANDLES, LIVING_BOOK_HANDLES } from "#/lib/homepage-curated";
import { cachedEnsureQueryData } from "#/lib/server-cache";
import { productQueries } from "#/queries/products";
import { regionQueries } from "#/queries/regions";
import { taxonomyQueries } from "#/queries/taxonomy";
import { AwardWinning } from "../components/home/AwardWinning.js";
import { BjuPressFeature } from "../components/home/BjuPressFeature.js";
import { Categories } from "../components/home/Categories.js";
import { FeaturedBooks } from "../components/home/FeaturedBooks.js";
import { LivingBooks } from "../components/home/LivingBooks.js";
import { LocalPartners } from "../components/home/LocalPartners.js";
import { OnSale } from "../components/home/OnSale.js";
import { Testimonials } from "../components/home/Testimonials.js";
import { TrustedPartners } from "../components/home/TrustedPartners.js";

const REGION_TTL_MS = 10 * 60 * 1000;
const TAXONOMY_TTL_MS = 5 * 60 * 1000;
const PRODUCT_TTL_MS = 60 * 1000;

export const Route = createFileRoute("/")({
  head: () => ({ meta: [{ title: "Learning Plus" }] }),
  loader: async ({ context: { queryClient } }) => {
    const [region] = await Promise.all([
      cachedEnsureQueryData<StoreRegion | null>(
        queryClient,
        regionQueries.default(),
        REGION_TTL_MS,
      ),
      cachedEnsureQueryData(
        queryClient,
        taxonomyQueries.brands(),
        TAXONOMY_TTL_MS,
      ),
    ]);
    await Promise.all([
      cachedEnsureQueryData(
        queryClient,
        productQueries.list(region?.id, {
          handles: FEATURED_BOOK_HANDLES,
          limit: FEATURED_BOOK_HANDLES.length,
        }),
        PRODUCT_TTL_MS,
      ),
      cachedEnsureQueryData(
        queryClient,
        productQueries.list(region?.id, {
          handles: LIVING_BOOK_HANDLES,
          limit: LIVING_BOOK_HANDLES.length,
        }),
        PRODUCT_TTL_MS,
      ),
    ]);
  },
  component: HomePage,
});

function HomePage() {
  return (
    <div data-screen-label="Homepage">
      <FeaturedBooks />
      <LivingBooks />
      <Categories />
      <TrustedPartners />
      <LocalPartners />
      <AwardWinning />
      <OnSale />
      <BjuPressFeature />
      <Testimonials />
    </div>
  );
}
